import React from "react";
import { View, Text } from "react-native";

import { FullscreenInput, TextInput } from "components";

import { styles } from "./styles";

export const BaseTextArea = props => {
  const textBoxStyles = [styles.textBox];
  const textStyles = [styles.text];

  if (props.isCorrect === true) {
    textBoxStyles.push(styles.correctBox);
    textStyles.push(styles.correctText);
  } else if (props.isCorrect === false) {
    textBoxStyles.push(styles.incorrectBox);
    textStyles.push(styles.incorrectText);
  }

  return (
    <View style={styles.container}>
      <View style={textBoxStyles}>
        <TextInput
          multiline={true}
          placeholderTextColor={styles._placeholder?.color}
          style={textStyles}
          numberOfLines={6}
          {...props}
        />
        {props.child}
      </View>
      <View style={styles.remainingView}>
        <Text style={styles.remainingText}>
          {props.maxLength - props.value.length} characters remaining
        </Text>
      </View>
    </View>
  );
};

export const TextArea = props => (
  <FullscreenInput component={BaseTextArea} {...props} />
);
